module.exports = __webpack_public_path__ + "db91996a7d206b94ab0e541965652966.png";